import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ResendEmailConfirmationGQL } from '../../../app/core/graphql/generated/graphql';
import { NavigationService } from '../../../app/services/navigation.service';
import { environment } from '../../../environments/environment';
import { SuccessPageConstants } from './success-page.constants';
import { USER } from "../../shared/components/demo-float-card/demo-float-card.constants";
import { RecaptchaComponent } from 'ng-recaptcha';

@Component({
    selector: 'app-success-page',
    templateUrl: './success-page.component.html',
    styleUrls: ['./success-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SuccessPageComponent implements OnInit {
    heading: string;
    message1: string;
    message2: string;
    emailLink: string;
    userEmailAddress: string;
    demoAccountButtonLabel: string;
    userId: string;
    userName: string;
    showSuccess: boolean;
    showFailure: boolean;
    recaptchaResponse: string;
    siteKey: string = environment.v2InvisibleRecaptchaSiteKey;
    @ViewChild('captchaRef') captchaRef: RecaptchaComponent;
    constructor(private resendEmailService: ResendEmailConfirmationGQL, private navigationService: NavigationService) {}

    ngOnInit(): void {
        this.userId = sessionStorage.getItem('userId')!;
        this.userName = sessionStorage.getItem('userName')!;
        this.heading = SuccessPageConstants.HEADING;
        this.message1 = SuccessPageConstants.DEMO_ACCOUNT_MESSAGE;
        this.message2 = SuccessPageConstants.EMAIL_MESSAGE;
        this.emailLink = SuccessPageConstants.SEND_EMAIL_MESSAGE;
        this.demoAccountButtonLabel = SuccessPageConstants.DEMO_ACCOUNT_BUTTON_LABEL;
        this.userEmailAddress = sessionStorage.getItem(USER.USER_EMAIL_ADDRESS)!;
    }

    resolved(captchaResponse: string | null): void {
        if (captchaResponse) {
            this.recaptchaResponse = captchaResponse;
            this.resendEmail();
        }
    }

    handleCaptchaError(): void {
        console.log('Captcha error');
    }

    resendEmail() {
        this.resendEmailService.mutate({ userName: this.userName, toEmail: this.userEmailAddress, recaptchaResponse: this.recaptchaResponse }).subscribe(
            (success) => {
                this.showSuccess = true;
            },
            (error) => {
                this.showFailure = true;
            }
        );
        this.captchaRef.reset();
    }

    closeModal(): void {
        this.showSuccess = false;
        this.showFailure = false;
    }

    redirectToSignInUrl(): void {
        this.navigationService.redirectBrowserTo(environment.realizeLoginUrl);
    }
}
